// extracted by mini-css-extract-plugin
export default {"checkoutInput":"CheckoutpromoCode_checkoutInput__2v79F","hasError":"CheckoutpromoCode_hasError__A-4fI","checkoutLabel":"CheckoutpromoCode_checkoutLabel__NCs6B"};